import * as React from 'react'
import { useDispatch } from 'react-redux'
import { Select, FormControl, InputLabel, Divider } from '@mui/material'
import { Box, MenuItem } from '@mui/material'
import FirstSearchBox from './FirstSearchBox'
import { updateFilterListByID } from '../../redux/slices/Search/input'

const SetUpFilterList = ({ windowWidth, idx, options, ...rest }) => {
  const dispatch = useDispatch()
  const DEFAULT_PROPS = { windowWidth, idx, ...rest }
  const IS_LAST = idx !== rest.lengthList - 1
  const WIDTHMIN = 600
  const BOXCONTAINER = {
    pb: 1,
    width: '100%',
    display: 'flex',
    flexWrap: windowWidth < WIDTHMIN ? 'wrap' : 'nowrap',
    flexDirection: windowWidth < WIDTHMIN ? 'column' : 'row',
    justifyContent: 'space-between',
  }

  const handleChangeOptions = e => {
    const { usedType, usedFilter1, usedFilter2, boxHeight } = rest
    dispatch(
      updateFilterListByID({
        someId: idx,
        someValue: {
          type: e.target.value,
          usedType,
          filterList1: [],
          usedFilter1,
          filterList2: [],
          usedFilter2,
          boxHeight,
        },
      })
    )
  }

  return (
    <Box sx={BOXCONTAINER}>
      <FormControl
        size="small"
        sx={{
          minWidth: !Boolean(rest.type)
            ? idx === 0
              ? '100%'
              : 'calc(100% - 35px)'
            : '200px',
          width: windowWidth < WIDTHMIN ? 'initial' : '200px',
        }}>
        <InputLabel id="advanced-search-label">Tipo de Categoría</InputLabel>
        <Select
          labelId="advanced-search-label"
          name="selectAdvancedBox"
          label="Tipo de categoría"
          value={rest.type}
          onChange={handleChangeOptions}>
          {options.map(obj => (
            <MenuItem key={`menuitem-key-${obj.value}`} value={obj.value}>
              {obj.label}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
      <FirstSearchBox {...DEFAULT_PROPS} />
      {windowWidth < WIDTHMIN ? (
        <Divider
          sx={{
            my: IS_LAST ? 1 : 0.25,
            width: '50%',
            alignSelf: 'center',
            borderBottomWidth: 'medium',
            borderColor: '#01007f29',
            borderBottomStyle: IS_LAST ? 'groove' : 'none',
          }}
        />
      ) : null}
    </Box>
  )
}
export default SetUpFilterList
